<ng-template #tabs>
	<div class="d-flex">
		<div class="px-3 py-4 selectable hoverable border-bottom d-flex align-items-center" [ngClass]="topTab === 'attention' ? 'border-4 border-primary' : 'border-lightergrey'" (click)="selectTopTab('attention')">
			<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': topTab !== 'attention' }">What needs your attention</span>
			<span *ngIf="moduleCounts.all" class="badge badge-{{topTab === 'attention' ? 'primary' : 'medium'}}">{{moduleCounts.all}}</span>
		</div>
		<div class="px-3 py-4 selectable hoverable border-bottom d-flex align-items-center" [ngClass]="topTab === 'announcements' ? 'border-4 border-primary' : 'border-lightergrey'" (click)="selectTopTab('announcements')">
			<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': topTab !== 'announcements' }">Announcements</span>
			<span *ngIf="announcementCount" class="badge badge-{{topTab === 'announcements' ? 'primary' : 'medium'}}">{{announcementCount}}</span>
		</div>
		<div class="flex-weight-1 border-bottom border-lightergrey"></div>
	</div>

	<div *ngIf="topTab === 'attention'" class="d-flex justify-content-center mt-3" style="font-size: 0.8rem;">
		<ui-tabs [tabs]="moduleTabsView" [activeTab]="moduleTab" (tabSelected)="selectModuleTab($event)"></ui-tabs>
	</div>
</ng-template>

<ng-template #rows>
	<table *ngIf="list" class="table table-hover m-0">
		<tbody>
			<tr *ngIf="selectMode && topTab === 'attention' && selectableList.length" class="select-all-row selectable" (click)="toggleSelectAll()">
				<td class="shrink align-middle pr-0" (click)="$event.stopPropagation()">
					<label class="custom-control custom-checkbox mb-0 selectable">
						<input type="checkbox" class="custom-control-input" [ngModel]="allSelected" (ngModelChange)="toggleSelectAll()">
						<span class="custom-control-label"></span>
					</label>
				</td>
				<td class="align-middle pl-0 text-small text-secondary text-bold text-uppercase">Select all</td>
			</tr>
			<tr *ngFor="let item of visibleList | pagination:pagination; trackBy: trackByAlertId" class="hover-parent" [ngClass]="{ 'table-danger': item.archived, 'table-success': item.resolved, 'table-primary': selectMode && isSelected(item) }">
				<td *ngIf="selectMode && topTab === 'attention'" class="shrink align-middle" (click)="$event.stopPropagation()">
					<label *ngIf="!item.resolved" class="custom-control custom-checkbox mb-0 selectable">
						<input type="checkbox" class="custom-control-input" [ngModel]="isSelected(item)" (ngModelChange)="toggleSelect(item)">
						<span class="custom-control-label"></span>
					</label>
				</td>
				<td class="selectable" (click)="onRowClick(item)">
					<div class="d-flex align-items-center">
						<div class="d-flex align-items-center justify-content-center mr-3" [ngClass]="item.dismissed ? 'text-secondary' : 'text-primary'" style="width: 2.5rem; flex: 0 0 auto;">
							<i class="{{getAlertIcon(item)}} h2 m-0"></i>
						</div>
						<div class="flex-weight-1">
							<div class="text-large" [ngClass]="{ 'text-bold': !item.dismissed }">{{item.title}}<span *ngIf="app.orgInfo?.role.is_elevated && item.name" class="text-small text-secondary"> - ({{item.name}})</span></div>
							<div *ngIf="item.body" class="text-small text-secondary text-truncate">{{item.body}}</div>
							<div class="text-small text-secondary mt-1 d-flex align-items-center">
								<span *ngIf="item.archived" class="badge bg-danger-10 text-danger mr-2">Archived</span>
								<span *ngIf="item.resolved" class="badge bg-success-10 text-success mr-2">Resolved</span>
								<span *ngIf="item.trigger_id" class="badge badge-light text-secondary mr-2" ngbTooltip="Trigger: {{item.trigger_id}}">{{getAlertModuleLabel(item)}}</span>
								<span>{{item.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{item.created_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</span>
							</div>
						</div>
						<div *ngIf="!selectMode" class="hover-child d-flex align-items-center ml-2 nowrap">
							<button *ngIf="app.orgInfo?.role.is_elevated && item.alert_type === 'wequote'" class="btn btn-sm btn-outline-secondary border-0 px-2" (click)="alertEditModal.open(item.id); $event.stopPropagation()" ngbTooltip="Edit"><i class="wq wq-edit"></i></button>
							<button *ngIf="!isAnnouncement(item) && !item.resolved" class="btn btn-sm btn-outline-secondary border-0 px-2" (click)="resolveItem(item, $event)" ngbTooltip="Mark as resolved"><i class="wq wq-check"></i></button>
							<button *ngIf="!isAnnouncement(item) && item.resolved" class="btn btn-sm btn-outline-secondary border-0 px-2" (click)="unresolveItem(item, $event)" ngbTooltip="Reopen"><i class="wq wq-undo"></i></button>
							<button *ngIf="!item.dismissed" class="btn btn-sm btn-outline-secondary border-0 px-2" (click)="dismissItem(item, $event)" ngbTooltip="Dismiss"><i class="wq wq-close"></i></button>
							<button *ngIf="item.action_url" class="btn btn-sm btn-outline-secondary border-0 px-2" (click)="openAlert(item); $event.stopPropagation()" ngbTooltip="Open"><i class="wq wq-open-new"></i></button>
						</div>
					</div>
				</td>
			</tr>
			<tr *ngIf="!pagination.count">
				<td class="text-secondary">No notifications found.</td>
			</tr>
		</tbody>
	</table>
</ng-template>

<ui-card *ngIf="!embedded" widget [wait]="list" [footer]="true" header="Notifications" [customHeader]="true" [customHeaderDivider]="false">
	<div class="d-flex align-items-center justify-content-end" ui-card-header>
		<span *ngIf="selectMode && topTab === 'attention'" class="subtitle mr-2">{{selected.size}} {{selected.size === 1 ? 'item' : 'items'}} selected</span>
		<button *ngIf="topTab === 'attention' && !selectMode" class="btn btn-outline-secondary border-0 mr-2" (click)="selectMode = true"><i class="wq wq-edit mr-2"></i>Bulk Edit</button>
		<button *ngIf="selectMode && topTab === 'attention'" class="btn btn-success mr-2" (click)="resolveSelected()" [disabled]="!selected.size"><i class="wq wq-check mr-2"></i>Mark as Resolved</button>
		<button *ngIf="selectMode && topTab === 'attention' && selected.size" class="btn btn-outline-secondary border-0 mr-2" (click)="clearSelection()"><i class="wq wq-close mr-2"></i>Clear</button>
		<button *ngIf="selectMode && topTab === 'attention'" class="btn btn-outline-secondary border-0 mr-2" (click)="selectMode = false"><i class="wq wq-check mr-2"></i>Done</button>
		<select class="custom-select custom-select-sm w-auto" [(ngModel)]="filter">
			<option value="all">All</option>
			<option value="unread">Show unread</option>
			<option value="unresolved">Show unresolved</option>
		</select>
	</div>
	<div class="my-nc" ui-card-custom-header>
		<ng-container *ngTemplateOutlet="tabs"></ng-container>
	</div>
	<ng-container *ngTemplateOutlet="rows"></ng-container>
	<app-pagination [pagination]="pagination" ui-card-footer></app-pagination>
</ui-card>

<div *ngIf="embedded" class="d-flex flex-column fill mt-n4">
	<div class="flex-shrink-0">
		<ng-container *ngTemplateOutlet="tabs"></ng-container>
	</div>
	<div class="flex-weight-1 scrollable mt-2">
		<ui-wait *ngIf="!list"></ui-wait>
		<ng-container *ngTemplateOutlet="rows"></ng-container>
	</div>
	<div class="flex-shrink-0 pt-2">
		<app-pagination [pagination]="pagination"></app-pagination>
	</div>
</div>

<modal-alert-popup></modal-alert-popup>
<app-alert-edit-modal (close)="refresh(false)"></app-alert-edit-modal>
